// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Site_TemplateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /site/v1/templates/{formulario}.
 *
 * `dados` IS the template — one form, one template, so there is nothing to wrap
 * it in. An unknown or inactive slug is a 404 envelope, never an empty success.
 */
import type { Site_TemplateRow } from './Site_TemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Site_TemplateResponseDados = Site_TemplateRow;

export type Site_TemplateResponse = ApiResponse<Site_TemplateResponseDados>;

registerResponseContract('Site_TemplateResponse', {
  formulario:    { type: 'string',  required: false },
  assunto:       { type: 'string',  required: false },
  corpo:         { type: 'string',  required: false },
  destinatarios: { type: 'array',   required: false },
  copias:        { type: 'array',   required: false },
  atualizado_em: { type: 'string',  required: false },
})
